import React from 'react';

export default function BannedView() {
  return (
    <main className="min-h-[var(--roddo-vh,100vh)] w-full bg-[#f7efe6] px-4 py-8 text-[#2f3d45] dark:bg-[#070B15] dark:text-[#f8f7ff]">
      <div className="mx-auto flex min-h-[calc(var(--roddo-vh,100vh)-4rem)] max-w-md items-center justify-center">
        <section className="w-full rounded-[20px] border border-black/10 bg-[#fffaf2] p-5 shadow-[0_10px_26px_rgba(89,65,37,0.10)] dark:border-[#9F8CDC]/18 dark:bg-[#151427] dark:shadow-[0_14px_34px_rgba(0,0,0,0.34)]">
          <div className="inline-flex rounded-[12px] border border-rose-300/40 bg-rose-100/70 px-3 py-1.5 text-[10px] font-black uppercase tracking-[0.16em] text-rose-800 dark:border-rose-300/20 dark:bg-rose-300/10 dark:text-rose-100">
            Account status
          </div>
          <h1 className="mt-3 text-2xl font-black leading-tight">Your Roddo account is unavailable.</h1>
          <p className="mt-2 text-sm leading-6 text-black/65 dark:text-white/68">
            This account has been restricted. If you believe this was a mistake, contact Roddo support for review.
          </p>
        </section>
      </div>
    </main>
  );
}
